import { onAuthStateChanged, signOut } from 'firebase/auth';
import React, { useEffect } from 'react'
import { auth } from '../utils/firebase';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addUser, removeUser } from '../utils/userSlice';
import { LOGO, SUPPORTED_LANGUAGES } from '../utils/constants';
import { toggleGptSearchView } from '../utils/gptSlice';
import { changeLanguage } from '../utils/configSlice';

const Header = () => {
  const navigate = useNavigate();
  const user = useSelector(store=> store.user);
  const dispatch = useDispatch();
  const showGptSearch = useSelector(store=>store.gpt.showGptSearch)

  useEffect(()=>{
    const unsubscribe  = onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/auth.user
          const {uid,email,displayName,photoURL} = user;
            dispatch(addUser({uid:uid,email:email,displayName:displayName,photoURL: photoURL}));
            navigate("/browse")
        } else {
          // User is signed out
            dispatch(removeUser());
            navigate("/");
        }
      });

      return ()=>unsubscribe();
},[])

  const handleGptSearchClick = () =>{
    //toggle GPT seacrch button
    dispatch(toggleGptSearchView())
  }
  const handleLanguageChange = (e) =>{
    dispatch(changeLanguage(e.target.value))
  }

  const handleSignout = ()=>{
    signOut(auth).then(() => {
      // Sign-out successful.
    }).catch((error) => {
      // An error happened.
      navigate("/error");
    });
  }

  return (
    <div className="absolute w-screen px-8 py-2 bg-gradient-to-b from-black z-10 flex flex-col md:flex-row justify-between">
        <img 
        className="w-44 mx-auto md:mx-0"
        src={LOGO}
        alt="logo" />
        
        {user && (<div className='flex p-2 justify-between'>
          {showGptSearch && (<select className="p-2 m-2 bg-gray-900 text-white" onChange={handleLanguageChange}>
            {SUPPORTED_LANGUAGES.map(lang=> <option key={lang.identifier} value={lang.identifier}>{lang.name}</option>)}
          </select>)}
          <button onClick={handleGptSearchClick}
          className="py-2 px-4 mx-4 my-2 bg-purple-800 text-white rounded-lg">
            {showGptSearch ? "Homepage" : "GPT Search"}</button>
          <img
          className='hidden md:block w-12 h-12' 
          alt="usericon" src={user?.photoURL}/>
          {/* && "https://occ-0-6323-2186.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABTZ2zlLdBVC05fsd2YQAR43J6vB1NAUBOOrxt7oaFATxMhtdzlNZ846H3D8TZzooe2-FT853YVYs8p001KVFYopWi4D4NXM.png?r=229"} */}
          <button
           onClick={handleSignout}
           className="font-bold text-white m-0 md:mx-2 ">Sign Out</button>
        </div>)}
    </div>
  )
}

export default Header